export const AddLabelButtonText = "Add label";
export const AddLabelWatermark = "Type to add a label";
export const LabelInGroup = "This label is already included";
export const LoadingSuggestions = "Loading...";
export const NewLabelSuggestionText = "New label";
